module.exports = __webpack_public_path__ + "img/关闭.0fff745d.png";